<div
  [ngClass]="{'__bfx-progressbar--warning': type == 'warning', '__bfx-progressbar--success': type == 'success'}"
  class="bfx-progressbar"
>
  <div
    class="__bfx-progressbar-ui-progressbar __bfx-progressbar-ui-widget __bfx-progressbar-ui-widget-content __bfx-progressbar-ui-corner-all"
    role="progressbar"
    aria-valuemin="0"
    [attr.aria-valuenow]="value"
    aria-valuemax="100"
  >
    <div
      class="__bfx-progressbar-ui-progressbar-value __bfx-progressbar-ui-progressbar-value-animate __bfx-progressbar-ui-widget-header __bfx-progressbar-ui-corner-all"
      [style.width]="value + '%'"
      style="display: block"
    >
      <div
        class="__bfx-progressbar-label"
        [style.display]="value ? 'block' : 'none'"
        *ngIf="showValue === true && showLabel === false"
      >
        {{displayValue}}{{unit}}
      </div>
      <div
        class="__bfx-progressbar-label"
        [style.display]="showLabel ? 'block' : 'none'"
        *ngIf="showLabel === true"
      >
        {{label}}
      </div>
    </div>
  </div>
</div>
